import { Box, SxProps } from '@mui/material';
import { ChangeEventHandler } from 'react';

import { useSxStyles } from './useStyles';

type PropsType = {
  label1: string;
  label2: string;
  label3: string;
  label4: string;
  val1: number;
  val2: number;
  val3: number;
  val4: number;
  editMode?: boolean;
  name: string;
  value: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
};

export const LegacyAbsBlock = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const {
    label1,
    label2,
    label3,
    label4,
    val1,
    val2,
    val3,
    val4,
    editMode,
    name,
    value,
    onChange,
  } = props;

  return (
    <>
      {editMode ? (
        <>
          <Box component="td" sx={sxStyles.editLabel1}>
            {label1}
          </Box>
          <Box component="td">
            <Box
              component="input"
              sx={sxStyles.input}
              name={name}
              value={value}
              onChange={onChange}
            />
          </Box>
        </>
      ) : (
        <LegacyAbsField label={label1} value={val1} sx={sxStyles.td} />
      )}
      <LegacyAbsField label={label2} value={val2} sx={sxStyles.td} />
      <LegacyAbsField label={label3} value={val3} sx={sxStyles.tdProgress} />
      <LegacyAbsField label={label4} value={val4} sx={sxStyles.td} />
    </>
  );
};

type PropsType2 = {
  label1: string;
  label2?: string;
  editMode?: boolean;
  name: string;
  value: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
};

export const LegacyAbsBlock2 = (props: PropsType2) => {
  const sxStyles = useSxStyles();
  const { editMode, label1, label2, name, value, onChange } = props;

  return (
    <>
      {!editMode ? (
        <>
          <Box component="td" sx={sxStyles.label1}>
            {label1}
          </Box>
          <Box component="td" sx={sxStyles.label2}>
            {label2}
          </Box>
          <Box component="td" sx={sxStyles.label3}>
            {value}
          </Box>
        </>
      ) : (
        <>
          <Box component="td" sx={sxStyles.label1}>
            {label1}
          </Box>
          <Box component="td" sx={sxStyles.label2}>
            {label2}
          </Box>
          <td>
            <Box
              component="input"
              sx={sxStyles.input}
              name={name}
              value={value}
              onChange={onChange}
            />
          </td>
        </>
      )}
    </>
  );
};

type PropsType3 = {
  label: string;
  editMode?: boolean;
  name: string;
  value: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
};

export const LegacyAbsBlock3 = (props: PropsType3) => {
  const sxStyles = useSxStyles();
  const { editMode, label, name, value, onChange } = props;

  return (
    <>
      {!editMode ? (
        <>
          <Box component="td" sx={sxStyles.label1}>
            {label}
          </Box>
          <Box component="td" sx={sxStyles.label3}>
            {value}
          </Box>
        </>
      ) : (
        <>
          <Box component="td" sx={sxStyles.label1}>
            {label}
          </Box>
          <td>
            <Box
              component="input"
              sx={sxStyles.input}
              name={name}
              value={value}
              onChange={onChange}
            />
          </td>
        </>
      )}
    </>
  );
};

export type Props = {
  label: string;
  value: number;
  sx: SxProps;
};

export const LegacyAbsField = (props: Props) => {
  const sxStyles = useSxStyles();
  const { label, value, sx } = props;
  return (
    <Box component="td" sx={sx}>
      <Box sx={sxStyles.leftDiv}>{label}</Box>
      <Box sx={sxStyles.rightDiv}>{value}</Box>
    </Box>
  );
};
